import { logEventAnalytics } from "../libs/amplitudeHelper";

// Auto-track por action.type: allowlist explícita de slices cuyos eventos SÍ
// se envían a Amplitude. Se preserva la lista de slices que autoenviaban en
// el legacy (con `createActions({ scope: { ... } })`) MENOS los que exponen
// PII o tokens. Cualquier evento fuera de esta allowlist debe declarar
// tracking explícito via `action.analytics` (ver bloque de opt-in arriba).
const ALLOWED_ANALYTICS_PREFIXES = [
  "business/canales/",
  "business/codigosPostales/",
  "business/localidades/",
  "business/marcaVehiculo/",
  "business/modeloVehiculo/",
  "business/polizaSelector/",
  "calcularCredito/",
  "calcularCreditoConsumo/",
  "creditos/detalleCredito/",
  "creditos/listadoCreditosVigentes/",
  "creditos/listadoCuotasCredito/",
  "creditos/pedidosDeCambio/",
  "mediosDePago/",
  "seguros/detallePoliza/",
  "seguros/listadoPolizas/",
  "reporteSolicitudes/",
  "terminosYCondiciones/",
];

const isAllowedForAutoAnalytics = (type) =>
  ALLOWED_ANALYTICS_PREFIXES.some((prefix) => type.startsWith(prefix));

const analyticsMiddleware = (store) => (next) => (action) => {
  if (action.analytics) {
    try {
      console.debug("Analytics track", action.analytics);

      logEventAnalytics(action.analytics.eventName, {
        ...action.analytics.eventData,
        deviceInfo: { ...store.getState().nativeMessagesReducer.deviceInfo },
      });
    } catch (error) {
      console.error("Analytics error", error);
    }
  }

  const sendToAnalytics =
    isAllowedForAutoAnalytics(action.type) &&
    !(action.meta && action.meta.doNotSendToAnalytics);

  if (sendToAnalytics) {
    try {
      logEventAnalytics(
        action.type,
        action.payload
          ? {
              ...action.payload,
              deviceInfo: {
                ...store.getState().nativeMessagesReducer.deviceInfo,
              },
            }
          : null
      );
    } catch (error) {
      console.error("Analytics error", error);
    }
  }

  return next(action);
};

export default analyticsMiddleware;
